var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"textMore",class:['text-more', _vm.isExpand ? 'expand' : '']},[_vm._v(" "+_vm._s(_vm.content)+" "),(_vm.isExpandBtn)?_c('div',{staticClass:"btn-more color-base underline",on:{"click":function($event){_vm.isExpand = !_vm.isExpand}}},[_vm._v(_vm._s(!_vm.isExpand ? '展开' : '收起'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }